module.exports = __webpack_public_path__ + "img/company-icon.08204734.svg";